import { toast } from "react-toastify";
import React, { useState, useEffect } from "react";
import { Button, Table, Form } from "react-bootstrap";
import axios from "axios";
import { API_BASE_URL } from "../../utils/config";
import NewTopNavBar from "../NewTopNavBar";
import { FaPlus, FaEdit, FaSave } from "react-icons/fa";

function ManageProjectPlatform() {
  const [platform, setPlatform] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [activePlatform, setActivePlatform] = useState("");
  const [jiraCred, setJiraCred] = useState({
    projectID: "",
    projectName: "",
    base_url: "",
  });
  const [tokenData, setTokenData] = useState({
    email: localStorage.getItem("userEmail"),
    redirectURI: "",
    projectID: "",
    projectName: "",
    portal_id: "",
  });
  const [showZohoInput, setShowZohoInput] = useState(false);
  const [showJiraInput, setShowJiraInput] = useState(false);

  let bearerToken = localStorage.getItem("jwt_token");
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };

  const fetchCurrentValue = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/wp-json/custom/v1/ticketing-platform-selection`,
        config
      );
      if (response.data) {
        setPlatform(response.data.value);
        setActivePlatform(response.data.value);
      }
    } catch (error) {
      console.error("Error fetching current option value:", error);
    }
  };

  const getTokenData = async () => {
    try {
      const zohoResponse = await axios.get(
        `${API_BASE_URL}/wp-json/zoho/v1/credentialsnew`,
        config
      );
      setTokenData(zohoResponse.data);

      const jiraResponse = await axios.get(
        `${API_BASE_URL}/wp-json/jira/v1/credentialsnew`,
        config
      );
      setJiraCred(jiraResponse.data);
    } catch (error) {
      console.error("Error fetching token data:", error);
    }
  };

  const handleSubmitCheckActive = async (platform) => {
    setActivePlatform(platform);

    try {
      await axios.post(
        `${API_BASE_URL}/wp-json/custom/v1/ticketing-platform-selection`,
        { value: platform },
        config
      );
    } catch (error) {
      console.error("Error updating active platform:", error);
    }
  };

  useEffect(() => {
    fetchCurrentValue();
    getTokenData();
  }, []);

  const handleInputChange = (e, platform) => {
    const { name, value } = e.target;
    if (platform === "zoho") {
      setTokenData((prevState) => ({ ...prevState, [name]: value }));
    } else {
      setJiraCred((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const handleSubmit = async (e, platform) => {
    e.preventDefault();
    const method = isEditMode ? "PUT" : "POST";

    try {
      if (platform === "zoho") {
        const url =
          method === "POST"
            ? `${API_BASE_URL}/wp-json/zoho/v1/credentialsnew`
            : `${API_BASE_URL}/wp-json/zoho/v1/credentialsnew`;

        const response = await axios.post(url, tokenData, config);

        if (response.data.status === "success") {
          toast.success(response.data.message);
        }

        setShowZohoInput(false);
      } else {
        const url =
          method === "POST"
            ? `${API_BASE_URL}/wp-json/jira/v1/credentialsnew`
            : `${API_BASE_URL}/wp-json/jira/v1/credentialsnew/edit`;

        // Send request to the server
        const response = await axios.post(url, jiraCred, config);

        if (response.data.status === "success") {
          toast.success(response.data.message);
        }

        setShowJiraInput(false);
      }

      getTokenData();
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Error saving data");
    }
  };

  return (
    <div>
      <NewTopNavBar />
      <div className="text-center pt-5 container">
        <h4 className="pb-5">Manage Project</h4>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Platform</th>
              {/* <th>Redirect URI</th>
              <th>Portal ID / Base URL</th>
              <th>Project ID</th>
              <th>Project Name</th>
              <th>Action</th> */}
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {/* Zoho Row */}
            <tr>
              <td className="text-center">
                <p style={{ marginTop: "10px" }}>Zoho</p>
              </td>

              {/* {showZohoInput ? (
                <>
                  <td>
                    <p style={{ marginTop: "8px" }}>
                      <Form.Control
                        type="text"
                        placeholder="Enter Redirect URI"
                        name="redirectURI"
                        value={tokenData.redirectURI}
                        onChange={(e) => handleInputChange(e, "zoho")}
                      />
                    </p>
                  </td>
                  <td>
                    <p style={{ marginTop: "8px" }}>
                      <Form.Control
                        type="text"
                        placeholder="Enter Portal ID"
                        name="portal_id"
                        value={tokenData.portal_id}
                        onChange={(e) => handleInputChange(e, "zoho")}
                      />
                    </p>
                  </td>
                  <td>
                    <p style={{ marginTop: "8px" }}>
                      <Form.Control
                        type="text"
                        placeholder="Enter Project Key"
                        name="projectID"
                        value={tokenData.projectID}
                        onChange={(e) => handleInputChange(e, "zoho")}
                      />
                    </p>
                  </td>
                  <td>
                    <p style={{ marginTop: "8px" }}>
                      <Form.Control
                        type="text"
                        placeholder="Enter Project Name"
                        name="projectName"
                        value={tokenData.projectName}
                        onChange={(e) => handleInputChange(e, "zoho")}
                      />
                    </p>
                  </td>
                  <td className="text-center">
                    <p style={{ marginTop: "0px" }}>
                      <Button
                        variant="primary"
                        onClick={(e) => handleSubmit(e, "zoho")}
                      >
                        <FaSave />
                      </Button>
                    </p>
                  </td>
                </>
              ) : (
                <>
                  <td className="text-center">
                    <p style={{ marginTop: "10px" }}>
                      {tokenData.redirectURI || "—"}
                    </p>
                  </td>
                  <td className="text-center">
                    <p style={{ marginTop: "10px" }}>
                      {tokenData.portal_id || "—"}
                    </p>
                  </td>
                  <td className="text-center">
                    <p style={{ marginTop: "10px" }}>
                      {tokenData.projectID || "—"}
                    </p>
                  </td>
                  <td className="text-center">
                    <p style={{ marginTop: "10px" }}>
                      {tokenData.projectName || "—"}
                    </p>
                  </td>
                  <td className="text-center">
                    <p style={{ marginTop: "0px" }}>
                      <Button
                        variant="primary"
                        title={tokenData.redirectURI ? "Edit" : "Add"}
                        onClick={() => setShowZohoInput(true)}
                      >
                        {tokenData.redirectURI ? <FaEdit /> : <FaPlus />}{" "}
                      </Button>
                    </p>
                  </td>
                </>
              )} */}
              <td className="text-center">
                <p style={{ marginTop: "0px" }}>
                  <Button
                    variant="secondary"
                    onClick={() => handleSubmitCheckActive("zoho")}
                  >
                    {activePlatform !== "zoho" ? "Activate" : "Active"}
                  </Button>
                </p>
              </td>
            </tr>

            {/* Jira Row */}
            <tr>
              <td className="text-center">
                <p style={{ marginTop: "10px" }}>Jira</p>
              </td>
              {/* {showJiraInput ? (
                <>
                  <td className="text-center">
                    <p style={{ marginTop: "10px" }}>—</p>
                  </td>
                  <td className="text-center">
                    <p style={{ marginTop: "10px" }}>
                      <Form.Control
                        type="text"
                        placeholder="Enter Base URL"
                        name="base_url"
                        value={jiraCred.base_url}
                        onChange={(e) => handleInputChange(e, "jira")}
                      />
                    </p>
                  </td>
                  <td className="text-center">
                    <p style={{ marginTop: "8px" }}>
                      <Form.Control
                        type="text"
                        placeholder="Enter Project Key"
                        name="projectID"
                        value={jiraCred.projectID}
                        onChange={(e) => handleInputChange(e, "jira")}
                      />
                    </p>
                  </td>
                  <td className="text-center">
                    <p style={{ marginTop: "8px" }}>
                      <Form.Control
                        type="text"
                        placeholder="Enter Project Name"
                        name="projectName"
                        value={jiraCred.projectName}
                        onChange={(e) => handleInputChange(e, "jira")}
                      />
                    </p>
                  </td>
                  <td className="text-center">
                    <p style={{ marginTop: "0px" }}>
                      <Button
                        variant="primary"
                        onClick={(e) => handleSubmit(e, "jira")}
                      >
                        <FaSave />
                      </Button>
                    </p>
                  </td>
                </>
              ) : (
                <>
                  <td className="text-center">
                    <p style={{ marginTop: "10px" }}>—</p>
                  </td>
                  <td className="text-center">
                    <p style={{ marginTop: "10px" }}>
                      {jiraCred.base_url || "—"}
                    </p>
                  </td>
                  <td className="text-center">
                    <p style={{ marginTop: "10px" }}>
                      {jiraCred.projectID || "—"}
                    </p>
                  </td>
                  <td className="text-center">
                    <p style={{ marginTop: "10px" }}>
                      {jiraCred.projectName || "—"}
                    </p>
                  </td>
                  <td className="text-center">
                    <Button
                      title={jiraCred.base_url ? "Edit" : "Add"}
                      variant="primary"
                      onClick={() => setShowJiraInput(true)}
                    >
                      {jiraCred.base_url ? <FaEdit /> : <FaPlus />}{" "}
                    </Button>
                  </td>
                </>
              )} */}
              <td className="text-center">
                <Button
                  variant="secondary"
                  onClick={() => handleSubmitCheckActive("jira")}
                >
                  {activePlatform !== "jira" ? "Activate" : "Active"}
                </Button>
              </td>
              
            </tr>
            <tr>
              <td className="text-center">ServiceNow</td>
              <td className="text-center">
                <Button
                  variant="secondary"
                  onClick={() => handleSubmitCheckActive("service_now")}
                >
                  {activePlatform !== "service_now" ? "Activate" : "Active"}
                </Button>
              </td></tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default ManageProjectPlatform;
